<template>
  <recycle-scroller
    class="radio-list-section"
    :class="[
      { 'radio-list-section--has-radio-data': playerRadioDataSet.length > 0 },
      `radio-list-section--${screenOrientationType}`,
    ]"
    :items="playerRadioDataSet"
    :item-size="isForPc ? 54 : 56"
    key-field="audio_clip"
    v-slot="{ item }"
  >
    <radio-list-item-parts
      :radioData="item"
      :screenOrientationType="screenOrientationType"
      @radioPlay="playRadioAudio"
    />
  </recycle-scroller>
</template>

<script lang="ts">
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { computed, defineComponent, PropType } from '@vue/composition-api'
import RadioListItemParts from '@/components/RaceVideoPage/RaceVideoRadioPane/parts/RadioListItemParts.vue'
import RadioDataDocument from '@/store/stores/collectionModule/documents/Radio/RadioDataDocument'
import DeviceInfo from '@/util/DeviceInfo'

/**
 * レース動画再生画面 無線一覧セクションのコンポーネント
 */
export default defineComponent({
  name: 'RadioListSection',
  components: {
    RadioListItemParts,
  },
  props: {
    /**
     * 画面向き
     */
    screenOrientationType: {
      type: String,
      default: 'portrait-primary',
    },
    /**
     * 選択選手無線データ
     */
    raceRadioData: {
      type: Array as PropType<RadioDataDocument[]>,
      default: () => [],
    },
  },
  setup(props) {
    const playerRadioDataSet = computed((): Array<RadioDataDocument> => props.raceRadioData)
    const isForPc = computed(() => DeviceInfo.isForPC())

    return {
      playerRadioDataSet,
      isForPc,
    }
  },
  methods: {
    /**
     * 無線 シングル再生
     * 選択したコンポーネント以外の再生状態をOFFにする
     * @event radioPlay
     */
    async playRadioAudio(radioData: RadioDataDocument, scene: boolean) {
      await this.$emit('radioPlay', radioData, scene)
    },
  },
})
</script>

<style lang="scss" scoped>
.radio-list-section {
  --race-select-height: calc(var(--screen-height) - 56.25vw - 44px);

  position: relative;
  height: var(--race-select-height);
  padding: 10px 24px calc(5em + (env(safe-area-inset-bottom) / 2));
  margin: 0 auto;
  overflow-y: auto;
  font-size: 12px;
  width: min(100%, 375px);

  @media screen and (max-width: 374px) {
    width: 230px;
    padding: 10px 8px 5em;
  }

  &--landscape-primary,
  &--landscape-secondary {
    max-width: 230px;
    height: calc(var(--screen-height) - 44px);
    font-size: 12px;
    padding: 0 8px 8px;
  }

  &--has-radio-data {
    &::before {
      position: absolute;
      top: 0;
      left: calc(50% - 1px);
      content: '';
      width: 2px;
      height: 10px;
      background-color: #e5e5e5;
    }
  }
}
</style>
